import type { Database } from '@auctisync/shared';
import { createClient, type SupabaseClient } from '@supabase/supabase-js';

/**
 * Supabase client for help.auctisync.com.
 *
 * Reads only — platform-scoped published help articles are readable by the
 * anon role via RLS (see supabase/migrations/20260418100000_help_center_schema.sql).
 * The only mutation is `help_article_record_view(slug)` RPC which bumps a
 * view_count counter; that's granted to anon explicitly.
 */

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase: SupabaseClient<Database> | null =
  supabaseUrl && supabaseAnonKey ? createClient<Database>(supabaseUrl, supabaseAnonKey) : null;
